const clientLogos = [
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/topgolf_600x600-300x300.png', alt: 'Topgolf' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/04/ccsi-logo-300x300.webp', alt: 'CCSI' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/04/craftmark-logo-300x300.webp', alt: 'Craftmark' },
  { src: 'https://www.verge.io/wp-content/uploads/2025/02/Lancaster.png', alt: 'Lancaster' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/04/Antillion-300x300.webp', alt: 'Antillion' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/04/iac-300x300.webp', alt: 'IAC' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/StClair_RESA_600x600_padded-300x300.png', alt: 'St. Clair RESA' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/04/EvolutionsLogo-OutsideGrey-300x300.webp', alt: 'Evolutions' },
  { src: 'https://www.verge.io/wp-content/uploads/2025/03/USAF_600-300x300.png', alt: 'US Air Force' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/04/institute-for-arts-culture-300x300.webp', alt: 'Institute for Arts & Culture' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/04/cage-cube-technologies-300x300.webp', alt: 'Cage Cube Technologies' },
  { src: 'https://www.verge.io/wp-content/uploads/2025/02/Formica-1.png', alt: 'Formica' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/04/arizona-state-university-logo-vertical.png-300x300.webp', alt: 'Arizona State University' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/04/U-M_Logo-Hex-300x300.webp', alt: 'University of Michigan' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/04/SkiBig3-Logo-2023-300x300.webp', alt: 'SkiBig3' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/Interbel_600x600_padded-300x300.png', alt: 'Interbel' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/Pfeiffer_University_600x600_padded-300x300.png', alt: 'Pfeiffer University' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/Alinsco_600x600-300x300.png', alt: 'Alinsco Insurance' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/CenterGrid_600x600_padded-300x300.png', alt: 'CenterGrid' },
  { src: 'https://www.verge.io/wp-content/uploads/2025/03/GDblue_600-copy-300x300.jpg', alt: 'GD' },
];

export default function TrustedBySection() {
  const doubled = [...clientLogos, ...clientLogos];
  return (
    <section className="bg-white py-12 overflow-hidden border-b border-gray-100">
      <div className="max-w-[1280px] mx-auto px-6 mb-6">
        <h3 className="text-center text-lg font-bold text-[#1a1a2e]">Kurumsal BT Ekiplerinin Güvendiği Çözüm</h3>
      </div>
      <div className="relative w-full overflow-hidden">
        <div className="flex gap-8 logo-marquee">
          {doubled.map((logo, idx) => (
            <div
              key={`${logo.alt}-${idx}`}
              className="flex-shrink-0 w-20 h-20 flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="max-w-full max-h-full object-contain grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
